import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsrange',
	templateUrl:'./BSRangePage.html',
	styles: [],
	styleUrls:['./BSRangePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSRangePage
{
	mdContent_154 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.range.BSRange;
\`\`\``;
	mdContent_155 = `\`\`\`java
new BSRange<>()
\`\`\``;
	mdContent_156 = `\`\`\`java
var range = new BSRange<>();
form.add(range);
\`\`\``;
}
